export default ["Per Annum", "Per Hour", "Per Month"];
